/**
 * A subset of the parent type's keys, all of which are required.
 */
export type RequiredPick<T, K extends keyof T> = Required<Pick<T, K>>;

/**
 * A copy of the parent type where all keys are optional except for those
 * specified which are required (regardless of whether they're optional/required
 * in the parent type)
 */
export type PartRequired<T, K extends keyof T> = Partial<T> &
  RequiredPick<T, K>;

export enum PaymentIntegrationType {
  STRIPE = "STRIPE",
  SQUARE = "SQUARE",
  ADYEN = "ADYEN",
}
